import {
  Icon,
  IconArrowUpRhombus,
  IconBasket,
  IconBrandCodesandbox,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconCash,
  IconCashBanknote,
  IconCategory,
  IconCategoryPlus,
  IconDiscount,
  IconFileInvoice,
  IconHome,
  IconLayoutDistributeHorizontal,
  IconManualGearbox,
  IconOutbound,
  IconPaperclip,
  IconReceipt,
  IconReportAnalytics,
  IconRulerMeasure,
  IconSettings,
  IconShoppingCart,
  IconSubtask,
  IconTicket,
  IconUserCog,
  IconUserPlus,
  IconUsers,
  IconWallet,
  IconGiftFilled,
  IconCoins,
  IconReceiptTax,
} from '@tabler/icons-react';
import { PermissionType } from './utils/authorization';
import { getPermittedNavigations } from './utils/getPermittedNavigations';

export type GroupItemWithChildren = {
  title: string;
  icon: Icon;
  path?: never;
  searchParams?: never;
  children: GroupItem[];
  badgeContent?: string;
  permission?: PermissionType;
};

export type GroupItemWithPath = {
  title: string;
  icon: Icon;
  path: string;
  searchParams?: {
    [field: string]: string;
  };
  children?: never;
  badgeContent?: string;
  permission?: PermissionType;
};

export type GroupItem = GroupItemWithPath | GroupItemWithChildren;

export type NavigationItem = {
  groupLable: string;
  permissions?: PermissionType[];
  items: GroupItem[];
};

const navigation: (params?: {
  badgeData: { batches: string; courses: string };
}) => NavigationItem[] = (params) => {
  const navigations: NavigationItem[] = [
    {
      groupLable: 'Dashboard',
      items: [
        {
          title: 'Dashboard',
          icon: IconHome,
          path: 'dashboard',
          permission: 'NAV_DASHBOARD',
        },

        {
          title: 'Admin Role',
          icon: IconUserCog,
          path: 'admin-role',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_USER_ROLE',
        },
        {
          title: 'Purchase Order',
          icon: IconShoppingCart,
          path: 'purchase-order',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_PURCHASE_ORDER',
        },

        {
          title: 'Supplier',
          icon: IconManualGearbox,
          path: 'supplier',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_SUPPLIER',
        },
        {
          title: 'Customer',
          icon: IconUserPlus,
          path: 'customer',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_CUSTOMER',
        },
         {
          title: 'Customer Group',
          icon: IconUserPlus,
          path: 'customer-group',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_CUSTOMER_GROUP',
        },
        {
          title: 'Invoice',
          icon: IconFileInvoice,
          path: 'invoice',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_INVOICE',
        },
        {
          title: 'Employee',
          icon: IconUsers,
          path: 'employee',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_EMPLOYEE',
        },
        {
          title: 'Top Customers And Products',
          icon: IconArrowUpRhombus,
          path: 'topcustomerandproducts',
          permission: 'NAV_TOP_CUSTOMERS_AND_PRODUCTS',
        },
        {
          title: 'Sales Comparison',
          icon: IconReportAnalytics,
          path: 'salescomparison',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_SALES_COMPARISON',
        },
        {
          title: 'Tasks',
          icon: IconSubtask,
          path: 'tasks',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_TASK',
        },
        {
          title: 'Tickets',
          icon: IconTicket,
          path: 'tickets',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_TICKET',
        },
      ],
    },
    {
      groupLable: 'Inventory',
      items: [
        {
          title: 'Product',
          icon: IconBasket,
          path: 'product',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_PRODUCT',
        },

        {
          title: 'Service',
          icon: IconSettings,
          path: 'service',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_SERVICE',
        },

        {
          title: 'Inventory',
          icon: IconBuildingWarehouse,
          path: 'inventory',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_INVENTORY',
        },

        {
          title: 'Outlet Inventory',
          icon: IconBuildingStore,
          path: 'outletinventory',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_OUTLET_INVENTORY',
        },
      ],
    },

    {
      groupLable: 'Marketing',
      items: [
        // {
        //   title: 'Coupons',
        //   icon: IconDiscount,
        //   path: 'coupons',
        //   searchParams: {
        //     page: '1',
        //     limit: '10',
        //   },
        //   permission: 'NAV_COUPONS_REFERRAL',
        // },

        // {
        //   title: 'Gift-Card',
        //   icon: IconOutbound,
        //   path: 'gift-card',
        //   searchParams: {
        //     page: '1',
        //     limit: '10',
        //   },
        //   permission: 'NAV_GIFT_CARD',
        // },

        {
          title: 'Loyalty',
          icon: IconPaperclip,
          path: 'loyalty',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_LOYALTY',
        },
        {
          title: 'Cashback Rules',
          icon: IconCoins,
          path: 'cashback-rules',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_LOYALTY',
        },
        {
          title: 'Rewards & Coupon',
          icon: IconGiftFilled,
          path: 'rewards-coupon',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_LOYALTY',
        },
        // {
        //   title: 'Promotion Coupons',
        //   icon: IconReceiptTax,
        //   path: 'promotion-coupons',
        //   searchParams: {
        //     page: '1',
        //     limit: '10',
        //   },
        //   permission: 'NAV_CASHBACK_RULES',
        // },
      ],
    },

    {
      groupLable: 'Configuration',
      items: [
         {
          title: 'Company',
          icon: IconBuildingWarehouse,
          path: 'company',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_COMPANY',
        },
        {
          title: 'Outlets',
          icon: IconLayoutDistributeHorizontal,
          path: 'outlets',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_OUTLET',
        },

        {
          title: 'Taxes',
          icon: IconReceipt,
          path: 'taxes',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_TAX',
        },

        {
          title: 'Category',
          icon: IconCategory,
          path: 'category',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_CATEGORY',
        },

        {
          title: 'Sub-Category',
          icon: IconCategoryPlus,
          path: 'sub-category',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_SUB_CATEGORY',
        },

        {
          title: 'Measurment Unit',
          icon: IconRulerMeasure,
          path: 'measurement-unit',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_MEASURMENT_UNIT',
        },

        {
          title: 'Payment Mode',
          icon: IconCash,
          path: 'payment-mode',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_PAYMENT_MODE',
        },

        {
          title: 'Brand',
          icon: IconBrandCodesandbox,
          path: 'brand',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_BRAND',
        },
        {
          title: 'Account',
          icon: IconWallet,
          path: 'account',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'NAV_ACCOUNT',
        },
        {
          title: 'Test Get Bookings',
          icon: IconCashBanknote,
          path: 'test-query-page',
          searchParams: {
            page: '1',
            limit: '10',
          },
          // permission: 'NAV_POS',
        },
      ],
    },
    {
      groupLable: 'Reports',
      
      items:[
        {
          title: 'Retail Dashbaord',
          icon: IconReceiptTax,
          path: 'outlet/retail-dashbaord',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'REPORT_RETAIL_DASHBOARD',
        },
        {
          title: 'Sales Report',
          icon: IconReceiptTax,
          path: 'outlet/sales-report',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'REPORT_SALES_BY_OUTLET',
        },
        //  {
        //   title: 'Outlets',
        //   icon: IconReceiptTax,
        //   path: 'outlet/outlet-report',
        //   searchParams: {
        //     page: '1',
        //     limit: '10',
        //   },
        //   permission: 'REPORT_OUTLET',
        // },
        {
          title: 'Gift Card Reports',
          icon: IconReceiptTax,
          path: 'outlet/gift-card-report',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'REPORT_GIFT_CARD',
        },
         
        {
          title: 'Register Closures',
          icon: IconReceiptTax,
          path: 'outlet/view-register',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'CLOSURE_SUMMARY',
        },
          {
          title: 'Payment Reports',
          icon: IconReceiptTax,
          path: 'outlet/payment-reports',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'PAYMENT_REPORTS',
        },
        {
          title: 'Cash movement report',
          icon: IconReceiptTax,
          path: 'outlet/cash-movement-report',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'CASH_MOVEMENT_REPORT',
        },
        //  {
        //   title: 'Sales Ledger',
        //   icon: IconReceiptTax,
        //   path: 'outlet/sales-ledger',
        //   searchParams: {
        //     page: '1',
        //     limit: '10',
        //   },
        //   permission: 'SALES_LEDGER',
        // },

        {
          title: 'Booking Summary',
          icon: IconReceiptTax,
          path: 'outlet/view-booking-data',
          searchParams: {
            page: '1',
            limit: '10',
          },
          permission: 'CLOSURE_SUMMARY',
        }
      ]
    },
    {
      groupLable:"POS",
      items:[
         {
          title: 'POS',
          icon: IconCashBanknote,
          path: 'pos',
          searchParams: {
            page: '1',
            limit: '10',
          },
          // permission: 'NAV_POS',
        },
      ]
    }
  ];

  return getPermittedNavigations(navigations);
};

export default navigation;
